/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import SelectBranchStudents from '../components/SelectBranchStudents.jsx';
import SelectClassStudents from '../components/SelectClassStudents.jsx';
import SelectSection from '../components/SelectSectionStudents.jsx';
import { hitApi } from '../utils/apiCall.js';
import { Link } from 'react-router-dom';

function StudentDetails() {
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [branchKeys, setBranchKeys] = useState([]);
  const [classKeys, setClassKeys] = useState([]);
  const [sectionKeys, setSectionKeys] = useState([]);
  const [isFormValid, setIsFormValid] = useState(false);

  const [branchFromComp, setBranchfromComp] = useState([])
  const [classFromComp, setClassfromComp] = useState([])
  const [sectionFromComp, setSectionfromComp] = useState([])

  const steps = [
    <SelectBranchStudents setBranchfromComp={setBranchfromComp} key="branch" />,
    <SelectClassStudents setClassfromComp={setClassfromComp} key="class" />,
    <SelectSection setSectionfromComp={setSectionfromComp} key="section" />
  ];

  const [stepValidations, setStepValidations] = useState([false, false, false]);

  useEffect(() => {
    const validateSelections = () => {
      const storedBranch = JSON.parse(localStorage.getItem("branch-students")) || {};
      const storedClass = JSON.parse(localStorage.getItem("class-students")) || {};
      const storedSection = JSON.parse(localStorage.getItem("section-students")) || {};

      const selectedBranches = Object.keys(storedBranch).filter(key => storedBranch[key]);
      const selectedClasses = Object.keys(storedClass).filter(key => storedClass[key]);
      const selectedSections = Object.keys(storedSection).filter(key => storedSection[key]);

      setBranchKeys(selectedBranches);
      setClassKeys(selectedClasses);
      setSectionKeys(selectedSections);

      setIsFormValid(selectedBranches.length > 0 && selectedClasses.length > 0 && selectedSections.length > 0);
    };

    validateSelections();
  }, []);

  // forStep Validation
  useEffect(() => {
    const storedBranch = branchFromComp || {};
    const storedClass = classFromComp || {};
    const storedSection = sectionFromComp || {};

    const selectedBranches = Object.keys(storedBranch).filter(key => storedBranch[key]);
    const selectedClasses = Object.keys(storedClass).filter(key => storedClass[key]);
    const selectedSections = Object.keys(storedSection).filter(key => storedSection[key]);

    // Update step validation
    setStepValidations([
      selectedBranches.length > 0, // Step 1 (Branch)
      selectedClasses.length > 0,  // Step 2 (Class)
      selectedSections.length > 0  // Step 3 (Section)
    ]);

    // Form is valid when all steps have selections
    setIsFormValid(selectedBranches.length > 0 && selectedClasses.length > 0 && selectedSections.length > 0);

  }, [branchFromComp, classFromComp, sectionFromComp])

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("branch", JSON.stringify(branchKeys));
    formData.append("class", JSON.stringify(classKeys));
    formData.append("section", JSON.stringify(sectionKeys));

    const res = await hitApi('your/api/endpoint', 'POST', formData);

    if (res.success) {
      console.log('Form submitted successfully', res);
    } else {
      console.log('Error in form submission', res);
    }
  };

  function next() {
    if (currentStepIndex < steps.length - 1) {
      setCurrentStepIndex(i => i + 1);
    }
  }

  function back() {
    if (currentStepIndex > 0) {
      setCurrentStepIndex(i => i - 1);
    }
  }

  const currentStep = steps[currentStepIndex];

  return (
    <div className="page-content-wrapper">
      <div className="container p-1" style={{ marginTop: "2rem" }}>
        <form id="getAttendanceForm" onSubmit={handleSubmit}>
          <input type="hidden" name="branch" value={JSON.stringify(branchKeys)} />
          <input type="hidden" name="class" value={JSON.stringify(classKeys)} />
          <input type="hidden" name="section" value={JSON.stringify(sectionKeys)} />
          {currentStep}
        </form>
      </div>

      <div style={{ bottom: '13%' }} className="position-fixed bg-white py-2 w-100 g-0 row">
        <div className="col-6 text-center">
          {currentStepIndex > 0 && (
            <button onClick={back} className="btn btn-primary" style={{ width: '95%' }}>
              Prev
            </button>
          )}
        </div>

        <div className="col-6 text-center">
          {
            currentStepIndex < steps.length - 1 ? (
              <button
                onClick={next}
                className="btn btn-primary"
                style={{ width: '95%' }}
                disabled={!stepValidations[currentStepIndex]} // Ensure current step is valid before proceeding
              >
                Next
              </button>
            ) : stepValidations.every(valid => valid) ? ( // Check if all steps are valid
              <Link
                style={{ width: '95%' }}
                to="/student-details-list"
                // onClick={handleSubmit}
                className="btn btn-primary">
                Proceed
              </Link>
            ) : (
              <button
                style={{ width: '95%' }}
                className="btn btn-secondary" disabled>
                Select all fields
              </button>
            )
          }
        </div>
      </div>
    </div>
  );
}

export default StudentDetails;
